export const BULK_EDIT_FEATURES = {
  moduleKey: 'bulk-edit',
  features: ['bulk-edit.execute'],
  featureMeta: {
    'bulk-edit.execute': {
      name: 'Bulk edit',
      translations: { name: { de: 'Massenbearbeitung', en: 'Bulk edit', fr: 'Modification en masse', it: 'Modifica in blocco' } },
    },
  },
  gatedByFlag: true,
} as const;
